import { SERVICE } from './constants'

export const HOME = `${SERVICE}/HOME`
export const HOME_SUCCESS = `${SERVICE}/HOME_SUCCESS`
export const HOME_ERROR = `${SERVICE}/HOME_ERROR`
export const SET_HOME_INFORMATION = `${SERVICE}/SET_HOME_INFORMATION`
export const RESET_HOME_INFORMATION = `${SERVICE}/RESET_HOME_INFORMATION`
